<template>
	<div class="hotel-list-item-storno">
		<div
			v-if="props.offerFeature"
			class="hotel-list-item-storno__container"
			role="status"
			aria-label="Flexible booking information"
			:aria-describedby="tooltip.elementId"
		>
			<BaseIcon
				class="hotel-list-item-storno__shield"
				name="shieldNew"
				@click.prevent
			/>
			<!-- prettier-ignore -->
			<span
				class="hotel-list-item-storno__text"
				@click.prevent
			>
				{{ FLEXIBLE_BOOKING_TEXT }}</span
			>
			<InfoTooltip
				:config="tooltip"
				placement="bottom"
				class="hotel-list-item-storno__tooltip"
				@click.prevent
			>
				{{ TOOLTIP_TEXT }}
			</InfoTooltip>
		</div>
	</div>
</template>

<script setup lang="ts">
import { defineProps, withDefaults } from 'vue';
import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import InfoTooltip from '@lmt-rpb/InfoTooltip/InfoTooltip.vue';
import { createTooltip } from '@lmt-rpb/InfoTooltip/tooltip-config';

type Props = {
	offerFeature: boolean;
};
const props = withDefaults(defineProps<Props>(), { offerFeature: false });
const tooltip = createTooltip();
const FLEXIBLE_BOOKING_TEXT = 'Flexibel buchen';
const TOOLTIP_TEXT =
	'Für dieses Hotel gibt es Angebote, die günstig oder kostenlos stornierbar und umbuchbar sind oder bei denen ein solcher flexibler Tarif zubuchbar ist. Die jeweiligen Angebote sind entsprechend gekennzeichnet.';
</script>
<style lang="scss" scoped>
.hotel-list-item-storno {
	&__container {
		display: flex;
		align-items: center;
	}

	&__text {
		font-size: $font-small-2;
		font-weight: 600;
		line-height: 2rem;
		color: $color-flex-filter;
	}

	&__shield {
		margin-inline-end: $spacer-1;
		width: 1.2rem;

		:deep(path) {
			fill: $color-flex-filter;
		}
	}

	&__tooltip {
		margin-inline-start: $spacer-2;
	}
}
</style>
